// This file is auto-generated at build time. Do not edit manually.
// See version.ts.example for the template.

export const version = {
  commit: 'bf09abe',
  tag: 'v3.52.0',
};
